import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import { Toaster } from "sonner";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Overview from "@/pages/Overview";
import SectorView from "@/pages/SectorView";
import CountryView from "@/pages/CountryView";
import EntityView from "@/pages/EntityView";
import Planning from "@/pages/Planning";
import Uploads from "@/pages/Uploads";
import Submissions from "@/pages/Submissions";
import Intercompany from "@/pages/Intercompany";
import OrgChart from "@/pages/OrgChart";
import EntityPortal from "@/pages/EntityPortal";
import ExecutivePack from "@/pages/ExecutivePack";
import BoardMeeting from "@/pages/BoardMeeting";

const Protected = ({ children }) => {
    const { user, loading } = useAuth();
    if (loading) return <div className="min-h-screen flex items-center justify-center text-fp-secondary font-sans text-sm">Loading…</div>;
    if (!user) return <Navigate to="/login" replace />;
    return children;
};

function App() {
    return (
        <AuthProvider>
            <BrowserRouter>
                <Toaster position="top-right" toastOptions={{ style: { borderRadius: 0, fontFamily: 'IBM Plex Sans' } }} />
                <Routes>
                    <Route path="/login" element={<Login />} />
                    <Route path="/board-meeting" element={<Protected><BoardMeeting /></Protected>} />
                    <Route path="/" element={<Protected><Layout /></Protected>}>
                        <Route index element={<Overview />} />
                        <Route path="sector/:sectorId" element={<SectorView />} />
                        <Route path="country/:countryCode" element={<CountryView />} />
                        <Route path="entity/:entityId" element={<EntityView />} />
                        <Route path="entity/:entityId/portal" element={<EntityPortal />} />
                        <Route path="executive-pack" element={<ExecutivePack />} />
                        <Route path="planning" element={<Planning />} />
                        <Route path="uploads" element={<Uploads />} />
                        <Route path="submissions" element={<Submissions />} />
                        <Route path="intercompany" element={<Intercompany />} />
                        <Route path="org" element={<OrgChart />} />
                    </Route>
                </Routes>
            </BrowserRouter>
        </AuthProvider>
    );
}

export default App;
